export const Credentials = {
   user: 'Ftc website',
   password: 'Travel2001',
   endpoint: 'https://api.bms.freshtracks.com'
}